import React from "react";
import { EditOrderData } from "@admin/domain/orders/dto/EditOrderData";

export default function PaymentUrl({ order }: { order: EditOrderData }) {
    if (!order.is_editable) {
        return null;
    }

    return (
        <a className="d-block w-max-content" href={order.payment_url} target="_blank">
            Ссылка для оплаты
        </a>
    );
}
